<template>
    <div class="salon-cars__contacts">
        <!--  v-if="company.active==0" -->
        <company-contacts-btn v-if="!isContactFormBlock" :company="company"/>
        <div class="salon-cars__contacts-flex">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 25" width="17px" height="25px">
                <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linejoin="round"
                   stroke-width="1.7647" opacity=".69999999" transform="translate(1 1)">
                    <path d="M15 7.5C15 14.302 7.5 23 7.5 23S0 14.464 0 7.5C0 3.3575 3.3575 0 7.5 0 11.642 0 15 3.3575 15 7.5z"></path>
                    <circle cx="8" cy="8" r="3"></circle>
                </g>
            </svg>
            <div class="salon-cars__contacts-block">
                <span>{{company.address}}</span>
                <a v-if="$store.state.isApp" href="javascript:void(0);" @click.prevent="openMap()"
                   class="contacts-map-link">+ Sjá staðsetningu á korti</a>

                <a v-else :href="getMapUrl" target="_blank"
                   class="contacts-map-link">+ Sjá staðsetningu á korti</a>
            </div>
        </div>

        <div v-if="company.work_time" class="salon-cars__contacts-flex">
            <ClockIcon/>
            <div class="salon-cars__contacts-block">
                <span>
                  {{company.work_time}}
                </span>
                <!-- <span>
                  Verkstæðismóttaka og varahlutir
                  Alla virka daga 7:45-18
                </span> -->

                <!-- <a v-if="$store.state.isApp"  href="javascript:void(0);" @click.prevent="webSite()" class="amount-cars-available__link">
                    {{company.website}}
                </a>

                <a v-else :href="getWebSiteUrl" target="_blank" class="contacts-map-link">
                    {{company.website}}
                </a> -->
            </div>
        </div>

        <!-- <company-contacts-btn v-if="company.active==1" :company="company"/> -->
    </div>
</template>

<script>
    import ClockIcon from "@/components/svg/clockIcon"
    import CompanyContactsBtn from "./CompanyContactsBtn";
    import getBaseUrl from "@/helpers/getBaseUrl";

    export default {
        props: {
            company: {
                type: Object
            },
            isContactFormBlock:{
                type: Boolean,
                default:false,
            }
        },
        components: {
            ClockIcon,
            CompanyContactsBtn
        },
        computed: {
            getMapUrl(){
                let address = this.company.address;
                if(!address && this.company.location){
                  address = this.company.location;
                }
                return 'https://maps.google.com/?q='+ address;
            },
            getWebSiteUrl() {
                return this.$store.state.viewSiteLink + this.$store.state.car_id;
            }
        },
        methods: {
            openMap(){
                let url = this.getWebSiteUrl;
                return window.open(url, '_blank', 'location=yes');
            },
            webSite() {
                let url = this.getWebSiteUrl;
                return window.open(url, '_blank', 'location=yes');
            }
        }
    }
</script>